import { useForm as reactHookUseForm } from 'react-hook-form';
import FormControls from './components';
import formValidators from './validators';
import { useFormHelpers as useFormHelpersFn } from './util';
export var Controls = FormControls;
export var useForm = reactHookUseForm;
export var useFormHelpers = useFormHelpersFn;
export var validators = formValidators;
export var options = {
  yesNo: [{
    label: 'Yes',
    value: true
  }, {
    label: 'No',
    value: false
  }],
  yesNoStringValues: [{
    label: 'Yes',
    value: '1'
  }, {
    label: 'No',
    value: '0'
  }]
};